<style scoped>
.canais-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.canal-badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 12px;
  letter-spacing: 0.3px;
  white-space: nowrap;
}

.canal-badge--b2b {
  background: #edf8f9;
  color: #1a7a83;
  border: 1px solid #c5e6e9;
}

.canal-badge--call {
  background: #f2f2f8;
  color: #3a3e81;
  border: 1px solid #dddce9;
}

.canal-badge--fv {
  background: #fef6ee;
  color: #b54708;
  border: 1px solid #f9dbaf;
}

.canal-badge--none {
  background: #f9fafb;
  color: #98a2b3;
  border: 1px solid #e4e7eb;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
  padding: 3px 10px;
  border-radius: 12px;
  white-space: nowrap;
}

.status-badge--ativo {
  background: #ecfdf3;
  color: #067647;
}

.status-badge--inativo {
  background: #fef3f2;
  color: #b42318;
}

.status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}

.status-badge--ativo .status-dot {
  background: #17b26a;
}

.status-badge--inativo .status-dot {
  background: #f04438;
}

.td-ref {
  font-size: 13px;
  color: #667085;
}
</style>

<template>
    <div>
        <Edit
            :item="currentItem"
            :close="closeEdit"
            :onSave="saveProduto"
            :camposSincronizados="camposSincronizados"
        />
        <Loading :isActive="loading"></Loading>
        <CTabs variant="tabs" class="nav-tabs-boxed">
        <CTab title="Produtos">
            <div class="filters row" style="margin-top:0">
                <div class="col-1-1">
                  <span class="filters__search">
                    <input
                            type="text"
                            v-model="termCod"
                            placeholder="Código"
                            v-on:keyup.enter="loadProdutos"
                    />
                  </span>
                    <span> ou </span>
                    <span class="filters__search">
                    <input
                            type="text"
                            v-model="termDesc"
                            placeholder="Descrição"
                            v-on:keyup.enter="loadProdutos"
                    />
                  </span>
                    <button class="button button-primary ml-1" v-on:click="loadProdutos()">
                        Buscar
                    </button>
                </div>
            </div>
            <div class="table-responsive">
                <datatable :columns="table.columns" :data="items" class="table table-hover">
                    <template slot-scope="{ row }">
                        <tr>
                            <td class="highlight">{{ row.id }}</td>
                            <td>
                                <img :src="cdnUrl(row.id)" class="thumbnail thumbnail-extra-small">
                            </td>
                            <td>{{ row.descComp }}</td>
                            <td class="td-ref">{{ row.codigoreferencia || '-' }}</td>
                            <td>
                                <div class="canais-badges">
                                    <span v-if="row.acessob2b" class="canal-badge canal-badge--b2b">B2B</span>
                                    <span v-if="row.acessocallcenter" class="canal-badge canal-badge--call">Call</span>
                                    <span v-if="row.acessofv" class="canal-badge canal-badge--fv">FV</span>
                                    <span v-if="!row.acessob2b && !row.acessocallcenter && !row.acessofv" class="canal-badge canal-badge--none">Nenhum</span>
                                </div>
                            </td>
                            <td>
                                <span class="status-badge" :class="row.ativo ? 'status-badge--ativo' : 'status-badge--inativo'">
                                    <span class="status-dot"></span>
                                    {{ row.ativo ? 'Ativo' : 'Inativo' }}
                                </span>
                            </td>
                            <td class="actions">
                                <button type="button" class="button button-primary" v-on:click="openEdit(row)">
                                    <fa-icon icon="pencil-alt" />
                                </button>
                            </td>
                        </tr>
                    </template>
                </datatable>
            </div>
            <div style="display: flex; justify-content: center;">
                <pagination
                        :data="table.paginator"
                        :limit="5"
                        @pagination-change-page="loadProdutos"
                ></pagination>
            </div>
        </CTab>
    </CTabs>
    </div>
</template>

<script>
import clone from 'just-clone';
import _map from 'lodash/map';
import TemplateModulo from '../../components/TemplateModulo';
import { get, post, put, del } from '@/helpers/apiRequest';
import Edit from './Edit';
import { cdnUrlProduto } from '../../helpers/url';
import { makeHash } from '../../helpers/utils';

export default {
  name: 'produtos',
  components: {
    Edit,
    TemplateModulo,
  },
  data() {
    return {
      currentItem: {},
      loading: false,
      error: false,
      items: [],
      termDesc: '',
      termCod: '',
      currentPage: 1,
      currentHash: makeHash(),
      camposSincronizados: [],
      table: {
        filter: '',
        columns: [
          { label: 'ID', field: 'id', align: 'center', sortable: false },
          { label: 'Imagem', field: 'imagem', sortable: false },
          { label: 'Descrição', field: 'descComp', sortable: false },
          { label: 'Cód. Referência', field: 'codigoreferencia', sortable: false },
          { label: 'Visibilidade', field: 'visibilidade', sortable: false },
          { label: 'Status', field: 'ativo', sortable: false },
          { label: '', field: '', sortable: false },
        ],
        paginator: {},
      },
    };
  },
  methods: {
    loadCamposSincronizados() {
      get('/admin/produtos/campos-sincronizados')
        .then((json) => {
          this.camposSincronizados = json.message || [];
        })
        .catch(() => {});
    },
    loadProdutos(page = 1) {
      this.currentPage = page;
      this.currentHash = makeHash();

      get(
        `/admin/produtos?page=${page}&filtros[produto_id]=${
          this.termCod
        }&filtros[termo]=${this.termDesc}`
      )
        .then((json) => {
          this.items = json.itens;
          this.table.paginator = json.paginator;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    refreshProdutos() {
      this.loadProdutos(this.currentPage);
    },
    openEdit(item) {
      this.currentItem = clone(item);
      this.currentItem.descComp = this.currentItem.descComp || "";
      this.currentItem.descNF = this.currentItem.descNF || "";
      this.currentItem.descricaofv = this.currentItem.descricaofv || "";
      this.currentItem.descricaobusca = this.currentItem.descricaobusca || "";
      this.currentItem.observacao = this.currentItem.observacao || "";
      this.currentItem.argVenda = this.currentItem.argVenda || "";
      this.currentItem.infoTecnicas = this.currentItem.infoTecnicas || "";
      this.currentItem.dadosTecnicos = this.currentItem.dadosTecnicos || "";
      this.currentItem.videos = this.currentItem.videos || "";
      this.currentItem.situacao_tributaria = this.currentItem.situacao_tributaria || "";
      this.$modal.show('produtoEdit');
    },
    closeEdit() {
      this.$modal.hide('produtoEdit');
      this.refreshProdutos();
    },
    saveProduto(persistirErp) {
      const produto = normalizeProdutoSalvar(this.currentItem, persistirErp);
      put(`/admin/produtos/${produto.id}`, produto)
        .then((json) => {
          this.closeEdit()
          this.$swal({
            title: 'Salvo com sucesso',
            text: json.message,
            showCancelButton: false,
            cancelButtonText: 'Fechar',
            showConfirmButton: true,
            icon: 'success',
          });
        })
        .catch((error) => {
          this.$swal({
            title: 'Falha ao Salvar',
            text: error.message,
            showCancelButton: true,
            cancelButtonText: 'Fechar',
            showConfirmButton: false,
            icon: 'error',
          });
        });
    },
    cdnUrl(id) {
      return cdnUrlProduto(id, this.currentHash);
    },
  },
  computed: {},
  beforeMount() {
    this.loadProdutos();
    this.loadCamposSincronizados();
  },
};

function normalizeProdutoSalvar(produto, persistirErp = false) {
  return {
    ...produto,
    similares: _map(produto.similares, 'id'),
    persistirErp,
  };
}
</script>
